<template>
  <div class="custom-file-upload">
    <!-- 上传按钮：修复原属性错误 + 开启multiple + 移动端兼容配置 -->
    <van-uploader
       v-model="filesList" 
       :show-upload = "false"
      v-if="fileList.length < maxCount"
      :after-read="handleAfterRead"
      :max-count="maxCount - fileList.length"
      :accept="compatibleAccept"
      :max-size="maxSize" 
      :before-read="beforeRead"
      :disabled="disabled"
      :multiple="true" 
      :capture="environment ? 'camera' : false" 
      @oversize="handleOversize" 
      :class="!uploaderBtnShow?'uploaderBtnShowBox':''"
    >
      <van-button icon="plus" type="primary" v-if="uploaderBtnShow" :disabled="disabled">
        上传文件
      </van-button>
    </van-uploader>

    <!-- 文件展示子组件：透传禁用状态，避免删除按钮失效 -->
    <fileComponent
      class="width-100"
      :fileListArr="fileList"
      :uploaderBtnShow="uploaderBtnShow"
      :disabled="disabled"
      @removeFile="handleFileRemove"
      ref="fileComponent"
    />
  </div>
</template>

<script>
import { upLoadFile } from "@/api/file";
import fileComponent from "./fileComponent.vue";
// 单独引入Toast，兼容Vue2/Vant的this.$toast可能失效的情况
import { Toast } from "vant";

export default {
  name: "MobileFileUpload",
  components: { fileComponent },
  props: {
    // 外部可自定义文件类型，内部做兼容处理
    accept: {
      type: String,
      default: ""
    },
    // 文件大小限制（默认50M）
    maxSize: {
      type: Number,
      default: 500 * 1024 * 1024
    },
    // 最大文件数量（默认50）
    maxCount: {
      type: Number,
      default:50
    },
    // 父组件文件列表 - 加默认值避免空值报错，开启双向绑定
    files: {
      type: Array,
      default: () => []
    },
    // 是否禁用上传/删除
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否强制调用摄像头（移动端）- 改为false更合理，默认不强制，注意：accept有值时个别安卓器可能无法识别，不会强制打开（建议：1. 默认不强制，2. 需要时父级组件不要配置accept）
    environment: {
      type: Boolean,
      default: false
    },
    // 上传模块类型，传给后端
    moduleType: {
      type: String,
      required: true,
      default: ''
    },
    //是否显示上传附件按钮(类似查看页面时使用,不能对附件进行操作)
    uploaderBtnShow: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    /**
     * 核心：兼容iOS/Android的accept值
     * iOS 优先识别MIME类型，Android 优先识别扩展名
     * 补充移动端缺失的MIME类型，覆盖图片/视频/所有办公文档
     */
    compatibleAccept() {
      // 若父组件自定义了accept，直接用自定义值；否则用默认兼容值
      if (this.accept) return this.accept;
      // 默认兼容值：兼顾MIME+扩展名，支持所有需要的文件类型
      return [
        // 图片：MIME+扩展名
        "image/*,.jpg,.jpeg,.png,.gif,.bmp,.webp",
        // 视频：MIME+扩展名
        "video/*,.mp4,.mov,.avi,.flv,.mkv",
        // 办公文档：MIME+扩展名（iOS重点补MIME）
        "application/msword,.doc",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document,.docx",
        "application/pdf,.pdf",
        "text/plain,.txt",
        "application/vnd.ms-excel,.xls",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xlsx",
         // PowerPoint 文档：添加PPT格式支持
        "application/vnd.ms-powerpoint,.ppt",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation,.pptx"
      ].join(",");
    }
  },
  data() {
    return {
      filesList: [], // 组件原有的图片列表数据（不可删除，否则表单验证定位不到）已样式隐藏
      fileList: [] // 本地维护的文件列表
    };
  },
  watch: {
    // 监听父组件文件列表变化，同步到本地 - 开启immediate替代mounted重复逻辑
    files: {
      handler(newVal) {
        console.log("文件列表变化：", newVal);
        this.syncParentFiles(newVal);
      },
      immediate: true,
      deep: true // 深度监听，处理父组件数组内对象变化
    }
  },
  methods: {
    // 公共方法：同步父组件文件列表，避免重复代码
    syncParentFiles(fileArr) {
      if (!Array.isArray(fileArr) || fileArr.length === 0) {
         this.filesList= this.fileList = [];
        return;
      }
      // 给父组件传的文件补充类型和默认状态
        this.filesList= this.fileList = fileArr.map(item => ({
        ...item,
        type: this.getFileType(item.name || item.url || item.fileName),
        status: item.status || "", // 补充状态字段
        message: item.message || ""
      }));
    },

    // 文件大小超限回调（Vant官方推荐用法）
    handleOversize(file) {
      console.log("文件大小超限：", file);
      let name = file.file.name || file.file.fileName||file.fileName||file.name;
      const maxMB = (this.maxSize / 1024 / 1024).toFixed(2);
      Toast(`文件${name}过大，最大支持${maxMB}MB`);
    },

    // 上传前前置检查
    beforeRead(file) {
      // 禁用状态直接拦截
      if (this.disabled) return false;
      
      // 数量限制由van-uploader的max-count自动处理，此处仅做兜底提示
      console.log("文件列表长度：", this.fileList.length);
      console.log("文件列表长度：", this.maxCount);
      if (this.fileList.length >= this.maxCount) {
        Toast(`最多可上传${this.maxCount}个文件`);
        return false;
      }
      
      // 根据accept属性验证文件类型
      const valid = this.validateFileType(file);
      if (!valid) {
        return false;
      }
      
      return true;
    },

    // 验证文件类型是否符合accept规则
    validateFileType(file) {
      // 如果没有设置accept，允许所有类型
      if (!this.accept && !this.compatibleAccept) {
        return true;
      }
      
      // 获取accept规则
      const acceptRules = this.accept || this.compatibleAccept;
      const rules = acceptRules.split(',').map(rule => rule.trim()).filter(rule => rule);
      
      // 处理单个文件或多个文件
      const files = Array.isArray(file) ? file : [file];
      
      for (const singleFile of files) {
        if (!this.isFileValid(singleFile, rules)) {
          // 获取允许的文件类型描述
          const allowedTypes = this.getReadableFileTypes(rules);
          Toast(`只能上传${allowedTypes}类型的文件`);
          return false;
        }
      }
      
      return true;
    },

  // 检查单个文件是否符合规则
  isFileValid(file, rules) {
    const fileName = file.name.toLowerCase();
    const fileType = file.type.toLowerCase();
    
    for (const rule of rules) {
      // 处理通配符规则，如 "image/*"
      if (rule.endsWith('/*')) {
        const mimeTypePrefix = rule.slice(0, -1); // 去掉 '*'
        if (fileType.startsWith(mimeTypePrefix)) {
          return true;
        }
      }
      // 处理具体MIME类型
      else if (rule.includes('/')) {
        if (fileType === rule) {
          return true;
        }
      }
      // 处理文件扩展名
      else if (rule.startsWith('.')) {
        if (fileName.endsWith(rule)) {
          return true;
        }
      }
      // 处理通配符
      else if (rule === '*') {
        return true;
      }
    }
    
    return false;
  },

// 获取可读的文件类型描述
getReadableFileTypes(rules) {
  const descriptions = [];
  
  for (const rule of rules) {
    if (rule === 'image/*') descriptions.push('图片');
    else if (rule === 'video/*') descriptions.push('视频');
    else if (rule === 'audio/*') descriptions.push('音频');
    else if (rule.includes('application/msword')) descriptions.push('Word文档');
    else if (rule.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document')) descriptions.push('Word文档');
    else if (rule.includes('application/pdf')) descriptions.push('PDF');
    else if (rule.includes('text/plain')) descriptions.push('文本文件');
    else if (rule.includes('application/vnd.ms-excel')) descriptions.push('Excel表格');
    else if (rule.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) descriptions.push('Excel表格');
    else if (rule.includes('application/vnd.ms-powerpoint')) descriptions.push('PowerPoint演示文稿');
    else if (rule.includes('application/vnd.openxmlformats-officedocument.presentationml.presentation')) descriptions.push('PowerPoint演示文稿');
    else if (rule.startsWith('.')) descriptions.push(`${rule.toUpperCase()}文件`);
  }
  
  return descriptions.length > 0 ? descriptions.join('、') : '指定类型';
},
    // 文件读取完成 - 支持单/多文件
    handleAfterRead(file) {
      if (this.disabled) return;
      // 统一转数组处理，兼容单/多文件
      const fileList = Array.isArray(file) ? file : [file];
      // 过滤掉超过剩余数量的文件
      const remainCount = this.maxCount - this.fileList.length;
      if (fileList.length > remainCount) {
        Toast(`还能上传${remainCount}个文件，已自动过滤多余文件`);
        fileList.splice(remainCount);
      }
      // 逐个上传
      fileList.forEach(item => this.uploadFile(item));
    },

    // 核心：文件上传逻辑（多文件状态独立）
    async uploadFile(fileItem) {
      try {
        let fileData={}
        // 1. 标记上传中状态，给子组件做UI展示
        fileData.status = "uploading";
        fileData.message = "上传中...";
        fileData.file = fileItem.file;
        // 2. 处理文件名特殊字符
        const processedFile = this.processFileName(fileData.file);
        // 3. 构建FormData
        const formData = new FormData();
        formData.append("file", processedFile);
        formData.append("moduleType", this.moduleType);
        // 4. 调用上传接口（单个文件单独请求，避免多文件一个失败全部失败）
        const res = await upLoadFile(formData);
        // 5. 处理后端返回数据，拼接完整文件链接
        if (res.data && res.data.servletRequestUrl && res.data.previewUrl) {
          res.data.fileURL = res.data.servletRequestUrl + res.data.previewUrl;
        }
        // 6. 合并返回数据到文件项，标记上传成功
        Object.assign(fileData, res.data);
        fileData.status = "success";
        fileData.message = "";
        // 7. 补充文件类型
        fileData.type = this.getFileType(processedFile.name || fileData.file.name);
        // 8. 添加到本地列表
        this.fileList.push(fileData);
        // 9. 通知父组件更新 - 深拷贝避免引用类型导致的更新失效
        this.$emit("success", JSON.parse(JSON.stringify(this.fileList)));
      } catch (err) {
        console.error("文件上传失败：", err);
        // 标记上传失败状态，给用户提示
        fileData.status = "fail";
        fileData.message = "上传失败，请重试";
        Toast(`文件${fileData.file.name}上传失败`);
      }
    },

    // 处理文件名特殊字符（保留原逻辑，对后端友好）
    processFileName(file) {
      if (!file || !file.name) return file;
      const nameParts = file.name.split(".");
      const extension = nameParts.length > 1 ? "." + nameParts.pop() : "";
      const baseName = nameParts.join(".");
      const processedBaseName = this.sanitizeFileName(baseName);
      const processedFileName = processedBaseName + extension;
      // 重新创建File对象，修改文件名
      return new File([file], processedFileName, {
        type: file.type,
        lastModified: file.lastModified
      });
    },

    // 清理文件名特殊字符（保留原逻辑）
    sanitizeFileName(fileName) {
      if (!fileName) return fileName;
      const replacements = {
        "(": "_",
        ")": "_",
        "[": "_",
        "]": "_",
        "+": "_",
        " ": "_",
        "#": "_",
        "%": "_",
        "&": "_",
        "=": "_",
        "<": "_",
        ">": "_",
        "{": "_",
        "}": "_",
        "|": "_",
        "\\": "_",
        "^": "_",
        "`": "_",
        "~": "_",
        "*": "_",
        "?": "_",
        '"': "'",
        ":": "-",
        ";": ","
      };
      let processedName = fileName;
      for (const [char, replacement] of Object.entries(replacements)) {
        const regex = new RegExp(this.escapeRegExp(char), "g");
        processedName = processedName.replace(regex, replacement);
      }
      // 移除连续下划线、首尾下划线/连字符
      processedName = processedName.replace(/_+/g, "_").replace(/^[_\-]+|[_\-]+$/g, "");
      return processedName;
    },

    // 正则特殊字符转义（保留原逻辑）
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    },

    // 判断文件类型（保留原逻辑，可扩展）
    getFileType(fileName) {
      if (!fileName) return "other";
      const lowerName = fileName.toLowerCase();
      // 图片类型
      const imageExts = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
      if (imageExts.some(ext => lowerName.endsWith(ext))) return "image";
      // 视频类型
      const videoExts = [".mp4", ".mov", ".avi", ".flv", ".mkv"];
      if (videoExts.some(ext => lowerName.endsWith(ext))) return "video";
      // 办公文档类型
      if (lowerName.endsWith(".pdf")) return "pdf";
      if (lowerName.endsWith(".doc") || lowerName.endsWith(".docx")) return "word";
      if (lowerName.endsWith(".xls") || lowerName.endsWith(".xlsx")) return "excel";
      if (lowerName.endsWith(".txt")) return "text";
      // 其他类型
      return "other";
    },

    // 处理文件删除（优化匹配逻辑，优先用Vant自带的uid，更稳定）
    handleFileRemove(fileItem) {
      console.log("handleFileRemove", this.fileList);
      console.log("handleFileRemove", fileItem);
      const index = this.fileList.findIndex(item => item.id === fileItem.id);
      if (index > -1) {
        this.fileList.splice(index, 1);
        // // 通知父组件更新 - 深拷贝
        // this.$emit("update:files", JSON.parse(JSON.stringify(this.fileList)));
        // 触发自定义删除事件，父组件可监听做额外操作
        this.$emit("fileRemove", fileItem);
      } else {
        console.warn("未找到要删除的文件：", fileItem);
      }
    }
  }
};
</script>

<style lang="scss" >
.custom-file-upload {
  width: 100%;
  .width-100 {
    width: 100%;
    margin-top: 10px;
  }
  .van-uploader{
    display: block;
    width: 100%;
    .van-uploader__wrapper{
      display: flex;
      -webkit-flex-wrap: wrap;
      flex-wrap: wrap;
      justify-content: flex-end;
    }
  }
  .van-uploader__preview{
    display: none;
  }
}
.uploaderBtnShowBox{
  display: block;
}
// 预览遮罩样式（保留原逻辑）
.preview-cover {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 4px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
}
</style>